import { Dispatch, SetStateAction, FC, Fragment } from 'react';
import _ from 'lodash';
import classNames from 'classnames';
import { useResponsive } from 'v3/common/hooks/useResponsive';
import { isMacPlatform } from 'v3/utils/os';
import SuggestedBrokers from '../SuggestedBrokers';
import ApplicationDomainUtility from 'v3/common/utils/applicationDomain';
import { initiateBrokerCallbackLogin } from 'common/auth/modalLogin';
import { reactToastify, TOASTIFY_TYPES } from 'v3/common/utils/reactToastify';
import { ACTIVE_BROKERS_DOMAINS } from '../types.type';

const { isCrypto } = ApplicationDomainUtility;

interface LoginButtonProps {
  domainOrPreviousLoggedInBrokerId: string | null;
  handlePreviouslyLoggedInBroker: () => void;
  setIsShowLoginModal: Dispatch<SetStateAction<boolean>>;
  isSubDomain: boolean;
}

const LoginButton: FC<LoginButtonProps> = ({
  setIsShowLoginModal,
  handlePreviouslyLoggedInBroker,
  domainOrPreviousLoggedInBrokerId,
  isSubDomain,
}) => {
  const isMobile = useResponsive();
  const brokerDisplayName = _.capitalize(_.split(domainOrPreviousLoggedInBrokerId, '_').join(' '));
  const shouldShowGoogleLogin =
    (window.currentDomain as string) === 'www' && window.SA_FEATURE_FLAGS.googleOauthEnabled;

  const combinedClassNames = classNames('change-broker-btn-shortcut', {
    'login-btn': !domainOrPreviousLoggedInBrokerId,
    'change-broker-btn': domainOrPreviousLoggedInBrokerId,
  });

  const usualLogin = (
    <>
      <div className="broker-buttons">
        {domainOrPreviousLoggedInBrokerId && (
          <button className="login-btn" onClick={handlePreviouslyLoggedInBroker}>
            Login With {_.toUpper(brokerDisplayName)}
            {isCrypto && brokerDisplayName == 'Delta exchange' && (
              <img src="/images/brokers/delta_exchange_logo.svg" />
            )}

          </button>
        )}
        <button onClick={() => setIsShowLoginModal((previous) => !previous)} className={combinedClassNames}>
          <span>{domainOrPreviousLoggedInBrokerId ? `Change Broker` : `Login With Broker`}</span>
          {!isMobile && <span className="shortcut-key">{isMacPlatform() ? `⌘ + K` : `Ctrl + K`}</span>}
        </button>
      </div>
      <Fragment>
        <div className="user-auth__divider">
          <hr />
          <span>{isCrypto ? 'or' : 'Or Login With'}</span>
          <hr />
        </div>
        {isCrypto ? (
          <button
            className="user-auth__google-btn"
            onClick={() =>
              initiateBrokerCallbackLogin('', true)
                .then((res) => (window.location.href = res.href))
                .catch(() =>
                  reactToastify('Google login failed. Please try again later.', TOASTIFY_TYPES.ERROR)
                )
            }
          >
            <img src="https://www.gstatic.com/firebasejs/ui/2.0.0/images/auth/google.svg" alt="Google icon" />
            <span>Continue with Google</span>
          </button>
        ) : (<>
          {shouldShowGoogleLogin && (
            <button
              className="user-auth__google-btn"
              onClick={(e) => {
                e.preventDefault();
                initiateBrokerCallbackLogin('', true)
                  .then((res) => (window.location.href = res.href))
                  .catch(() =>
                    reactToastify('Google login failed. Please try again later.', TOASTIFY_TYPES.ERROR)
                  );
              }}
            >
              <img src="google.svg" alt="google-img" />
              <span>Continue with Google</span>
            </button>
          )}
        </>)}
        {!isCrypto && <SuggestedBrokers handlePreviouslyLoggedInBroker={handlePreviouslyLoggedInBroker} />}
      </Fragment>
    </>
  );

  // TODO this is for creating an account
  // Can be used for all brokers to ask to create an account.
  // Clean this up, if it grows further with more brokers
  const handleCreateAccount = () =>
    window.open('https://web-cug.stocko.in/sign-up', '_blank', 'noopener,noreferrer');

  const brokerName = _.toUpper(brokerDisplayName);
  return (
    <div className="user-auth__login">
      {isSubDomain
        ? domainOrPreviousLoggedInBrokerId && (
          <div className="broker-buttons">
            <button className="login-btn" onClick={handlePreviouslyLoggedInBroker}>
              {` Login With ${brokerName === 'COIN DCX' ? '' : brokerName}`}
              {isCrypto && brokerDisplayName == 'Coin dcx' && (
                <img className='btn-logo' alt='CoinDCX' src="/images/brokers/coindcx_whitebg_logo.svg" />
              )}
            </button>
            {window.currentDomain === ACTIVE_BROKERS_DOMAINS.STOCKO && (
              <button onClick={handleCreateAccount} className={combinedClassNames}>
                <span>Create An Account</span>
              </button>
            )}
          </div>
        )
        : usualLogin}
    </div>
  );
};

export default LoginButton;
